import { render, staticRenderFns } from "./PreferencesFooter.vue?vue&type=template&id=6092151b"
import script from "./PreferencesFooter.vue?vue&type=script&lang=js"
export * from "./PreferencesFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports